import React from "react";
import { Section } from "../../../atoms/section";
import { Header } from "../../../molecules/header";
import { useStore } from "../../../../store";
import { SECTIONS } from "../../../../constants/sections";
import { SavingsListItem } from "../../../molecules/savings-list-item";
import { Flex } from "../../../atoms/flex";
import { Graph } from "../../../molecules/graph";
import { Wave } from "../../../atoms/wave";
import { UNITS } from "../../../../constants/units";
import { Text } from "../../../atoms/text";

/**
 * Carbon dioxide section component
 */
export const CarbonDioxide = () => {
  const {
    data = {
      carbonDioxideSavings: 0,
      carbonDioxideRed: 0,
      cO2NoMimbox: 0,
      cO2Mimbox: 0,
    },
    loading,
  } = useStore();
  const {
    carbonDioxideSavings: carbonDioxideSavingsKG = 0,
    cO2NoMimbox: cO2NoMimboxKG,
    cO2Mimbox: cO2MimboxKG,
  } = data;

  const useGrams = carbonDioxideSavingsKG < 1;

  const savings = useGrams
    ? Math.round(carbonDioxideSavingsKG * 1000)
    : carbonDioxideSavingsKG.toFixed(1);

  const unit = useGrams ? UNITS.GRAMS : UNITS.KILO;

  const cO2NoMimbox = useGrams
    ? Math.round(cO2NoMimboxKG * 1000)
    : cO2NoMimboxKG;
  const cO2Mimbox = useGrams ? Math.round(cO2MimboxKG * 1000) : cO2MimboxKG;

  return (
    <>
      <Wave className="fill-gray" variant={2} />
      <Section className="bg-gray" id={SECTIONS.CARBON_DIOXIDE} wave>
        <Header
          icon="carbon-dioxide"
          title={SECTIONS.CARBON_DIOXIDE}
          subTitle={`${savings}${unit} minskat utsläpp, en minskning på ${Math.round(
            data?.carbonDioxideRed || 0
          )}${UNITS.PERCENT}`}
          loading={loading}
        ></Header>
        <Flex className="section-content">
          <Graph
            description="CO2 Utsläpp"
            max={cO2NoMimbox}
            min={cO2Mimbox}
            unit={unit}
            loading={loading}
          />
          <Flex className="savings-list">
            <SavingsListItem
              text="Koldioxid som förbrukas vid framställning av el."
              value="0.231"
              unit={UNITS.KILO_PER_KWH}
              loading={loading}
            />
            <SavingsListItem
              text="Koldioxidekvivalenter som förbrukas vid hantering av
                    avloppsvatten vid reningsverk."
              value="0.344"
              unit={UNITS.KILO_PER_CUBIC}
              loading={loading}
            />
            <SavingsListItem
              text="Koldioxidekvivalenter som förbrukas vid framställning av
                    drickvatten."
              value="0.708"
              unit={UNITS.KILO_PER_CUBIC}
              loading={loading}
            />
            <Text className="text-reference" align="left" fontStyle="italic">
              **Siffror baserade på “greenhouse gas reporting: conversion
              factors 2020”
              https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2020
            </Text>
            <p className="sub-text"></p>
          </Flex>
        </Flex>
      </Section>
    </>
  );
};
